<script context="module">
  import { External, M } from '../external';
  import VideoService from './VideoService.svelte';

  let selectedVideo = null;
  //if the folder is selected, this will be used to store the selected videos
  let selectedVideosFromFolder = [];

  //used for selecting video from builder
  export function chooseVideo(callback, showSelectFolder) {
    External.Tools.showWindow({
      noTitle: true,
      width: 800,
      isModal: false,
      showCloseButton: true,
      withDarkBackground: true,
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new VideoService({
              target: popup.getContentArea(),
              props: {
                onClose: () => {
                  popup.close();
                },
                showSelectFolder: showSelectFolder,
                showSelect: true
              }
            })
          );
        },
        onHide: (popup, ui) => {
          if (selectedVideosFromFolder.length > 0) {
            callback(selectedVideosFromFolder);
            selectedVideosFromFolder = [];
          } else if (selectedVideo) {
            callback(selectedVideo);
            selectedVideo = null;
          }
        }
      }
    });
  }

  export function listVideos() {
    External.Tools.showWindow({
      noTitle: true,
      width: 800,
      isModal: false,
      showCloseButton: true,
      withDarkBackground: true,
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new VideoService({
              target: popup.getContentArea(),
              props: {
                onClose: () => {
                  popup.close();
                }
              }
            })
          );
        }
      }
    });
  }
</script>

<script>
  import {
    defaultErrorHandling,
    deleteVideoService,
    getVideoService,
    postVideoService
  } from './static';
  import VideoFolderObject from './Admin/VideoFolderObject.svelte';
  import Loader from '../Common/Loader.svelte';
  import VideoFolderListObject from './Admin/VideoFolderListObject.svelte';
  import VideoFolderCreate from './Admin/VideoFolderCreate.svelte';
  import VideoAnalytic from './Analytic/VideoAnalytic.svelte';

  //properties used when component is opened as video chooser popup
  export let onClose = () => {
  };
  export let showSelectFolder = false;
  export let showSelect = false;

  let show = 'LOADER';
  let videoFolders = {};
  let selectedFolder = {};
  let selectedFolderId = -1;

  let fetchVideoFolders = () => {
    getVideoService('/folder/all', {})
    .then(folders => {
      if (folders && folders.length) {
        for (const videoFolder of folders) {
          videoFolder['avgEngagement'] = 0;
          videoFolders[videoFolder.id] = videoFolder;
        }
        videoFolders = videoFolders; //refresh the UI
        show = 'LIST';
      } else {
        show = 'EMPTY';
      }
    }).catch(err => {
      defaultErrorHandling();
    });
  };

  $: fetchVideoFolders();

  let backToAllFolders = () => {
    show = 'LIST';
    selectedFolderId = -1;
  };

  let selectFolder = (folder) => {
    selectedFolder = folder;
    selectedFolderId = folder.id;
    show = 'FOLDER';
  };

  let onSelectFolderContent = (folder) => {
    getVideoService('/folder/' + folder.id)
    .then(videos => {
      if (videos && videos.length > 0) {
        selectedVideosFromFolder = videos.filter(video => video.jobStatus === 'COMPLETE');
      }
      onClose();
    });
  };

  let createOrRenameFolder = (folderId) => {
    let newFolderName = '';
    let onFolderNameChange = (changedName) => {
      newFolderName = changedName;
    };
    let isRename = Number.isInteger(folderId);
    if (isRename) {
      newFolderName = videoFolders[folderId].name;
    }
    let showing = show;
    External.Tools.showWindow({
      title: '',
      width: 450,
      isModal: false,
      withDarkBackground: true,
      buttons: [
        External.Button(M.OK, External.Button.CLASS_MIDDLE_BLUE, (popup) => {
          popup.close();
          if (newFolderName) {
            show = 'LOADER';
            let endpoint = '/folder';
            if (isRename) {
              endpoint += '/' + folderId + '/rename';
            }
            postVideoService(endpoint, {}, { name: encodeURIComponent(newFolderName) })
            .then((newFolder) => {
              if (isRename) {
                videoFolders[folderId].name = newFolderName;
                show = showing;
              } else {
                newFolder.videoFilesCount = 0;
                newFolder.videoFiles = [];
                videoFolders[newFolder.id] = newFolder;
                newFolderName = '';
                selectFolder(newFolder);
              }
            })
            .catch(err => defaultErrorHandling());
          }
        }),
        External.Button(M.CANCEL, External.Button.CLASS_MIDDLE_GREY, (popup) => {
          popup.close();
        })
      ],
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new VideoFolderCreate({
              target: popup.getContentArea(),
              props: {
                folderName: newFolderName,
                onFolderNameChange: onFolderNameChange
              }
            })
          );
        }
      }
    });
  };


  let removeFolder = (folderName, folderId) => {
    External.Tools.prompt(M.DELETE_FOLDER, External.format(M.DEL_CONFIRM_EXT, 'ext', folderName), () => {
      show = 'LOADER';
      deleteVideoService('/folder/' + folderId)
      .then(() => {
        delete videoFolders[folderId];
        videoFolders = videoFolders; //refresh the UI
        show = Object.keys(videoFolders).length ? 'LIST' : 'EMPTY';
      })
      .catch(err => {
        show = 'LIST';
        defaultErrorHandling();
      });
    });
  };

  let showAnalyticPopup = () => {
    External.Tools.showWindow({
      title: '',
      height: 750,
      width: 1000,
      isModal: false,
      withDarkBackground: true,
      showCloseButton: true,
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new VideoAnalytic({
              target: popup.getContentArea(),
              props: {
                type: 'owner'
              }
            })
          );
        }
      }
    });
  };

  let selectVideo = (videoObject) => {
    selectedVideo = videoObject;
    onClose();
  };


</script>

<div class="col20 f-left popup-widget-wrapper">
  <!--
  <div class="top-background-wrapper wide-top-background">
    <div class="top-background" style="max-width: 1000px;">
      <div class="text-wrapper">
        <div class="flex space-between align-center col20 f-left">
          <div class="flex align-center flex-none">
            <h1 class="members-title quiz-title f-left t-left mb-0 mr-25 flex-none">Video Manager</h1>
            <ul class="upper-navigation upper-navigation-full f-left col20">
              <li><a class="active">Content</a></li>
              <li><a on:click={showAnalyticPopup}>Analytics</a></li>
            </ul>
          </div>
          <div>
            {#if show === 'FOLDER'}
             <a class="middle-button blue with-icon mr-5" on:click={uploadVideo}>Upload A Video!</a>
            {:else}
              <a class="middle-button blue with-icon" on:click={createOrRenameFolder}>Create A Folder</a>
            {/if}
          </div>
        </div>
      </div>
    </div>
  </div>-->

  <h4 class="col20 f-left mt-25 mb-25 t-center h4-bigger">{M.VIDEO_MANAGER}</h4>

  <div class="col20 f-left flex align-center justify-center mb-15">
    {#if show === 'FOLDER'}
    {:else if show !== 'EMPTY'}
      <a on:click={showAnalyticPopup} class="light-gray-btn rounded-effect middle-button f-right mr-5">{M.ANALYTICS}</a>
      <a class="middle-button blue with-icon f-right" on:click={createOrRenameFolder}>{M.CREATE_A_FOLDER}</a>
    {/if}

  </div>

  <div class="padded-crm-wrapper-video">
    {#if show === 'LIST'}
      {#each Object.entries(videoFolders) as [folderId, folderObject]}
        <VideoFolderListObject bind:videoFolderData={folderObject} selectFolder={selectFolder} onSelectFolderContent={onSelectFolderContent}
                               removeFolder={removeFolder} showSelectFolder={showSelectFolder} renameFolder={createOrRenameFolder} />
      {/each}
    {:else if show === 'FOLDER'}
      <VideoFolderObject folder={selectedFolder} allFolders={videoFolders} backToAllFolders={backToAllFolders}
                         renameFolder={createOrRenameFolder} showSelect={showSelect} selectVideo={selectVideo} />
    {:else if show === 'EMPTY'}
      <div class="empty-folder-message col20 f-left">
        <span class="col20 f-left t-center">{M.NO_FOLDERS}</span>
        <div class="col20 f-left mt-35 t-center"><a class="middle-button blue with-icon f-none inline-block"
                                                    on:click={createOrRenameFolder}>{M.CREATE_A_FOLDER}</a></div>
      </div>
    {:else}
      <Loader />
    {/if}
  </div>

</div>
